
import Vue from 'vue'
// import { VAvatar } from 'vuetify/lib'

// Mixins
// import Colorable from 'vuetify/lib/mixins/colorable'

export default Vue.extend({
  props: {
    user: Object,
    color: {
      type: String,
      default: 'primary',
    },
    dark: Boolean,

    size: {
      type: [Number, String],
      default: 48,
    },
  },
})
